import { useLanguage } from '@/contexts/AppContext';
import type { OrderData, TaxInvoiceTranslations } from './types';
import { formatDate } from './constants';

interface OrderInfoSectionProps {
  orderData: OrderData;
  t: TaxInvoiceTranslations;
}

export function OrderInfoSection({ orderData, t }: OrderInfoSectionProps) {
  // #522: 15 locale 전수 — formatDate 도 Locale 시그니처.
  const { locale } = useLanguage();
  return (
    <div>
      <h3 className="font-medium text-gray-900 mb-3">{t.orderInfo}</h3>
      <div className="bg-gray-50 rounded-lg p-4 space-y-2">
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">{t.orderNumber}</span>
          <span className="font-mono">{orderData.orderId}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">{t.date}</span>
          <span>{formatDate(orderData.timestamp, locale)}</span>
        </div>
      </div>
    </div>
  );
}
